import { Box, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

interface IProps {
  message: string;
}

function ErrorStatusLine({ message }: IProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: '6px', ml: '-2px' }}>
      <WarningAmberRoundedIcon color='error' />
      <div>
        {message.split('\n').map((error, index) => (
          <Typography variant='h4' key={index} sx={{ mt: '6px', ml: '9px', mb: '9px', fontWeight: 'normal' }}
            color='error'> {index === 0 && <b>Error!</b>}  {error}
          </Typography>
        ))}
      </div>
    </Box>
  );
}

export default ErrorStatusLine;
